export default __webpack_public_path__ + "static/media/AtkinsonHyperlegibleMono-Regular.c4c8b4b4.woff2";